import React, { useState, useContext } from "react";
import { ProductContext } from "../context/ProductContext";
import { useNavigate } from "react-router-dom";
import {
  FaInfoCircle,
  FaLeaf,
  FaWarehouse,
  FaImage,
  FaMoneyBillWave,
  FaCamera,
} from "react-icons/fa";

import "../styles/AddProduct.css";
import hsnDatabase from "../data/hsnDatabase";
function AddProduct() {

  const navigate = useNavigate();

  const {

  editingProduct

} = useContext(ProductContext);

const [gstRate, setGstRate] = useState(
  editingProduct?.gstRate || localStorage.getItem("preferredGstRate") || "18"
);

const [hsnCode, setHsnCode] =
  useState(
    editingProduct?.hsnCode || ""
  );

const [
  productCategory,
  setProductCategory
] = useState(
  editingProduct?.productCategory || ""
);

  const {

  addProduct,

  updateProduct,

  products,

  setEditingProduct,

} = useContext(ProductContext);
   const [activeImage, setActiveImage] =
  useState("");

  const [customCategory, setCustomCategory] =
  useState(false);

  const [formData, setFormData] =
  useState({

    primaryUnit:
  editingProduct?.primaryUnit || "",

secondaryUnit:
  editingProduct?.secondaryUnit || "",

conversionRate:
  editingProduct?.conversionRate || "",

    id: editingProduct?.id || "",

    name:
      editingProduct?.name || "",

    category:
      editingProduct?.category || "",

    brand: editingProduct?.brand || "",  

    sku:
      editingProduct?.sku || "",

    botanical:
      editingProduct?.botanical || "",

    units:
      editingProduct?.units || "",

    price:
      editingProduct?.price?.replace("₹", "") || "",

    mrpPrice:
      editingProduct?.mrpPrice?.replace("₹", "") || "",  

    image:
      editingProduct?.image || "",

      image2:
  editingProduct?.image2 || "",
  });
  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };

 const handleImageUpload = (e) => {

  const file = e.target.files[0];

  if (!file) return;

  const reader = new FileReader();

reader.onloadend = () => {

  setFormData((prev) => ({
    ...prev,
    image: reader.result,
  }));

  setActiveImage(reader.result);

};

reader.readAsDataURL(file);

};

const handleImageUpload2 = (e) => {

  const file = e.target.files[0];

  if (!file) return;

  const reader = new FileReader();

reader.onloadend = () => {

  setFormData((prev) => ({
    ...prev,
    image2: reader.result,
  }));

  setActiveImage(reader.result);

};

reader.readAsDataURL(file);

};

{formData.image && (

  <img
  src={formData.image}
  alt="Preview"
  className="small-preview"
  onClick={() =>
    setActiveImage(formData.image)
  }
/>

)}

  const handleSave = () => {

    const finalCategory =

  formData.category === "Custom"
    ? newCategory
    : formData.category;

  const units = Number(formData.units);

  let stock = "IN STOCK";
  let statusClass = "in-stock";

  if (units <= 10) {
    stock = "LOW STOCK";
    statusClass = "low-stock";
  }

  if (units === 0) {
    stock = "OUT OF STOCK";
    statusClass = "out-stock";
  }

  const productData = {

  ...formData,

  brand: formData.brand,

  category: finalCategory,

  gstRate:
    Number(gstRate || 0),

  hsnCode,

  productCategory,

  stock,
  statusClass,

  price: `₹${formData.price}`,
  mrpPrice: `₹${formData.mrpPrice || 0}`,
  image:
    formData.image ||
    "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=400",

};

  if (editingProduct) {

    updateProduct(productData);

  } else {

    addProduct(productData);

  }

  setEditingProduct(null);

  navigate("/products");
};

const categoryList = [

  ...new Set(
    products
      .map((item) => item.category)
      .filter(Boolean)
  ),

];

const [newCategory, setNewCategory] =
  useState("");

const salePrice = Number(formData.price || 0);
const gstPercent = Number(gstRate || 0);
const estimatedGST = (salePrice * gstPercent) / 100;
const finalRetailPrice = salePrice + estimatedGST;

  return (
    <div className="add-product-page">

      <div className="breadcrumb">
        INVENTORY &gt; ADD NEW PRODUCT
      </div>

      <div className="page-header">

        <h1>New Inventory Item</h1>

        <div className="header-buttons">

          <button
  type="button"
  className="cancel-btn"
  onClick={() => {

    setEditingProduct(null);

    navigate("/products");

  }}
>

  CANCEL

</button>

          <button
  className="save-add-btn"
  onClick={() => {

    const finalCategory =

      formData.category === "Custom"
        ? newCategory
        : formData.category;

    const productData = {

  ...formData,

  category: finalCategory,

  gstRate:
    Number(gstRate || 0),

  hsnCode,

  productCategory,

};

    if (editingProduct) {

      updateProduct(productData);

    } else {

      addProduct(productData);

    }

    setEditingProduct(null);

    setFormData({

      name: "",
      sku: "",
      brand: "",
      category: "",

      botanicalName: "",
      sunlight: "",
      water: "",

      price: "",
      stock: "",
      mrpPrice: "",
      primaryUnit: "",
      secondaryUnit: "",
      conversionRate: "",

      image: "",
      image2: "",

    });

    setActiveImage("");

    setCustomCategory(false);

    setNewCategory("");

  }}
>

  SAVE & ADD ANOTHER

</button>

          <button
            className="save-btn"
            onClick={handleSave}
          >
            SAVE PRODUCT
          </button>

        </div>

      </div>

      <div className="product-layout">

        <div className="left-sections">

          {/* GENERAL INFORMATION */}

          <div className="form-card">

            <div className="section-title">
              <FaInfoCircle />
              <span>General Information</span>
            </div>

            <div className="form-group">
              <label>Product Name</label>

              <input
                type="text"
                name="name"
                value={formData.name}
                placeholder="e.g. Premium Heirloom Tomato Seeds"
                onChange={handleChange}
              />

              {formData.name.length > 14 && (
  <small className="product-name-warning">
    Keep product name within 14 letters for single-line bill printing.
  </small>
)}
            </div>

            <div className="form-row">

              <div className="form-group">
                <label>SKU</label>

                <input
                  type="text"
                  name="sku"
                  value={formData.sku}
                  placeholder="GARD-SEED-001"
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Brand/Manufacturer</label>

                <input
                  type="text"
                  name="brand"
                  value={formData.brand}
                  placeholder="Nature's Legacy"
                  onChange={handleChange}
                />
              </div>

            </div>

            <div className="form-group">
              <label>Category</label>

              <select
                name="category"
                value={formData.category}
                onChange={(e) => {

  handleChange(e);

  setCustomCategory(
    e.target.value === "Custom"
  );

}}
              >
                <option value="">
  Select Category
</option>
<option value="Custom">
  + Add New Category
</option>

{categoryList.map((cat, index) => (

  <option
    key={index}
    value={cat}
  >
    {cat}
  </option>

))}
              </select>
              {customCategory && (

  <input
    type="text"
    placeholder="Enter category name"
    value={newCategory}
    onChange={(e) =>
      setNewCategory(e.target.value)
    }
  />

)}


            </div>

          </div>

          {/* GARDENING SPECIFICS */}

          <div className="form-card">

            <div className="section-title">
              <FaLeaf />
              <span>Gardening Specifics</span>
            </div>

            <div className="sub-heading">
              PLANT & SEED DETAILS
            </div>

            <div className="form-row">

              <div className="form-group">
                <label>Botanical Name</label>

                <input
                  type="text"
                  name="botanical"
                  value={formData.botanical}
                  placeholder="Solanum lycopersicum"
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Hardiness Zone</label>

                <input
                  type="text"
                  placeholder="3-10"
                />
              </div>

            </div>

            <div className="form-row">

              <div className="form-group">
                <label>Sunlight Requirements</label>

                <select>
                  <option>Full Sun</option>
                </select>
              </div>

              <div className="form-group">
                <label>Water Needs</label>

                <select>
                  <option>Low</option>
                </select>
              </div>

            </div>

            <div className="sub-heading">
              TOOL & EQUIPMENT DETAILS
            </div>

            <div className="form-row">

              <div className="form-group">
                <label>Warranty Period</label>

                <input
                  type="text"
                  placeholder="e.g. 12 Months"
                />
              </div>

              <div className="form-group">
                <label>Power Source</label>

                <select>
                  <option>Manual</option>
                </select>
              </div>

            </div>

          </div>

          {/* INVENTORY LOGISTICS */}

          <div className="form-card">

            <div className="section-title">
              <FaWarehouse />
              <span>Inventory Logistics</span>
            </div>

            <div className="form-row">

              <div className="form-group">
                <label>Initial Stock</label>

                <input
                  type="number"
                  name="units"
                  value={formData.units}
                  placeholder="0"
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Reorder Point</label>

                <input
                  type="text"
                  placeholder="10"
                />
              </div>

              <div className="form-group">
                <label>Aisle/Shelf</label>

                <input
                  type="text"
                  placeholder="B-12-04"
                />
              </div>

              <div className="form-group">

  <label>
    Primary Unit
  </label>

  <select
    name="primaryUnit"
    value={formData.primaryUnit}
    onChange={handleChange}
  >

    <option value="">
      Select Unit
    </option>

    <option value="Kg">Kg</option>
    <option value="Gram">Gram</option>
    <option value="Bag">Bag</option>
    <option value="Box">Box</option>
    <option value="Bottle">Bottle</option>
    <option value="Liter">Liter</option>
    <option value="PCS">PCS</option>

  </select>

</div>

<div className="form-group">

  <label>
    Secondary Unit (Unit 2)
  </label>

  <select
    name="secondaryUnit"
    value={formData.secondaryUnit}
    onChange={handleChange}
  >

    <option value="">
      Select Unit
    </option>

    <option value="Kg">Kg</option>
    <option value="Gram">Gram</option>
    <option value="Bag">Bag</option>
    <option value="Box">Box</option>
    <option value="Bottle">Bottle</option>
    <option value="Liter">Liter</option>
    <option value="PCS">PCS</option>

  </select>

</div>

<div className="form-group">

  <label>
    Conversion Rate
  </label>

  <input
    type="number"
    name="conversionRate"
    value={formData.conversionRate}
    placeholder="1 Bag = 25 Kg"
    onChange={handleChange}
  />

</div>

            </div>

          </div>

          {/* BOTTOM IMAGE */}

          <div className="bottom-banner">

            <img
              src="https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?w=1200"
              alt=""
            />

            <div className="banner-overlay">

              <h4>Inventory Health Tip</h4>

              <p>
                Ensure accurate HSN codes for garden seeds to
                claim maximum GST input tax credits under
                standard horticultural exemptions.
              </p>

            </div>

          </div>

        </div>

        {/* PRICING */}

          <div className="form-card">

            <div className="section-title">
              <FaMoneyBillWave />
              <span>Pricing & GST</span>
            </div>

            <div className="form-group">

              <label>Unit Price (₹)</label>

              <input
                type="number"
                name="price"
                value={formData.price}
                placeholder="0.00"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
  <label>MRP Price</label>
  <input
    type="number"
    name="mrpPrice"
    value={formData.mrpPrice}
    placeholder="0.00"
    onChange={handleChange}
  />
</div>

            

            <div className="form-group">
              <label>GST Tax Rate</label>

              <select
  value={gstRate}
  onChange={(e) => {
    const newRate = e.target.value;
    setGstRate(newRate);
    localStorage.setItem("preferredGstRate", newRate);
  }}
>
  <option value="">
    Select GST Rate
  </option>

  <option value="0">
    0% (Nil Rated)
  </option>

  <option value="5">
    5%
  </option>

  <option value="12">
    12%
  </option>

  <option value="18">
    18% 
  </option>

  <option value="28">
    28%
  </option>
</select>
            </div>

            <div className="form-group">
              <label>HSN Code</label>

              <input
  type="text"
  placeholder="Enter HSN Code"
  value={hsnCode}
  maxLength={8}
  onChange={(e) => {

    const value =
      e.target.value.replace(/\D/g, "");

    setHsnCode(value);

    // AUTO DETECT
    if (hsnDatabase[value]) {
      const detectedGst = hsnDatabase[value].gst;
      
      setGstRate(detectedGst);
      localStorage.setItem("preferredGstRate", detectedGst);
      
      setProductCategory(hsnDatabase[value].name);
    }

  }}
/>
            </div>

            <div className="price-summary">

  <div>
    <span>Price (Excl. Tax)</span>
    <strong>
      ₹{salePrice.toFixed(2)}
    </strong>
  </div>

  <div>
    <span>Estimated GST</span>
    <strong>
      ₹{estimatedGST.toFixed(2)}
    </strong>
  </div>

  <div className="final-price">
    <span>Final Retail Price</span>
    <strong>
      ₹{finalRetailPrice.toFixed(2)}
    </strong>
  </div>

</div>

            <label className="checkbox-row">

              <input type="checkbox" />

              <span>
                Apply promotional discount
              </span>

            </label>

          </div>

        {/* RIGHT SIDE */}

        <div className="right-sections">

          {/* PRODUCT MEDIA */}

          <div className="product-media-box">

  <div className="section-title">
    <FaImage />
    <span>Product Media</span>
  </div>

 {activeImage ? (

  <img
    src={activeImage}
    alt="Preview"
    className="image-preview"
  />

) : (

  <div className="upload-placeholder">

    <div className="upload-icon">
      📄
    </div>

    <h3>Drop images here</h3>

    <p>
      or click to browse files
    </p>

    <small>
      JPG, PNG up to 5MB
    </small>

  </div>

)}

  

  <div className="media-action-row">
    
    <label
  className="upload-btn"
  tabIndex="-1"
>

  Upload Image

  <input
    type="file"
    accept="image/*"
    onChange={handleImageUpload}
    style={{ display: "none" }}
  />

</label>
            <div className="multi-image-upload">

  {/* IMAGE 1 */}

  <div className="small-upload-box">

  {formData.image ? (

    <div className="preview-wrapper">

      <button
        type="button"
        className="remove-image-btn"
        onClick={(e) => {

          e.preventDefault();

          setFormData((prev) => ({
  ...prev,
  image: "",
}));

if (activeImage === formData.image) {
  setActiveImage("");
}

        }}
      >
        ×
      </button>

      <img
        src={formData.image}
        alt="Preview"
        className="small-preview"
        onClick={() =>
          setActiveImage(formData.image)
        }
      />

    </div>

  ) : (

    <label className="upload-overlay">

      <span>📷</span>

      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        hidden
      />

    </label>

  )}

</div>

  {/* IMAGE 2 */}

  <div className="small-upload-box">

  {formData.image2 ? (

    <div className="preview-wrapper">

      <button
        type="button"
        className="remove-image-btn"
        onClick={(e) => {

          e.preventDefault();

          setFormData((prev) => ({
  ...prev,
  image2: "",
}));

if (activeImage === formData.image2) {
  setActiveImage("");
}

        }}
      >
        ×
      </button>

      <img
        src={formData.image2}
        alt="Preview"
        className="small-preview"
        onClick={() =>
          setActiveImage(formData.image2)
        }
      />

    </div>

  ) : (

    <label className="upload-overlay">

      <span>📷</span>

      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload2}
        hidden
      />

    </label>

  )}

</div>
</div>
</div>

          </div>

          

        </div>

      </div>

    </div>
  );
}

export default AddProduct;